import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import Multiselect from 'multiselect-react-dropdown'
import { isEmpty, masterAndChildIntersection } from '../../../utils/helper'
import { CustomDescriptionBox } from '../../../../components'

const UserGroupModal = ({
  openModal,
  onCancel,
  roleData,
  userData,
  groupData,
  addCallback,
  editCallback,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedEditRoles, setSelectedEditRoles] = useState([])

  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedEditUsers, setSelectedEditUsers] = useState([])

  const [errorData, setErrorData] = useState({})

  useEffect(() => {
    if (!isEmpty(groupData)) {
      handleEdit()
    }
  }, [])

  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const handleSelect = (info, type, state, func) => {
    let temp = state
    if (type === 'add' && temp.indexOf(info._id) === -1) {
      temp.push(info._id)
    } else if (type === 'remove') {
      temp = temp.filter((id) => id !== info._id)
    }
    func(temp)
  }

  const handleEdit = () => {
    setName(groupData.name)
    setDescription(groupData.description)

    setSelectedUsers(groupData.users)

    let tempRole = []
    roleData.forEach((ele) => {
      let roleIndex = groupData.roles.findIndex((e) => e === ele._id)
      if (roleIndex > -1) {
        tempRole.push(ele)
      }
    })
    const roleIntersectionData = masterAndChildIntersection(roleData, tempRole)
    setSelectedRoles(roleIntersectionData.map((obj) => obj._id))
    setSelectedEditRoles(roleIntersectionData)

    let tempUsers = []
    userData.forEach((ele) => {
      let userIndex = groupData.users.findIndex((e) => e === ele._id)
      if (userIndex > -1) {
        tempUsers.push(ele)
      }
    })
    setSelectedEditUsers(tempUsers)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (!name && name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name cannot be Empty!'
    }
    if (isEmpty(selectedRoles)) {
      isFormValid = false
      temp.selectedRoles = 'roles cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = async () => {
    if (validateInfo()) {
      let payload = {
        name: name,
        description: description,
        roles: selectedRoles,
        users: selectedUsers,
      }
      isEmpty(groupData) ? addCallback(payload) : editCallback(payload, groupData._id)
    }
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{isEmpty(groupData) ? `Add` : `Edit`} User Group</CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol>
              <CustomDescriptionBox
                title="Description"
                rows={1}
                value={description}
                onChange={setDescription}
                limit={100}
              />
            </CCol>
          </CRow>

          <CRow className="mt-3">
            <CCol lg="12">
              <CFormLabel>Select Roles*</CFormLabel>
              <Multiselect
                options={roleData} // Options to display in the dropdown
                selectedValues={!isEmpty(groupData) ? selectedEditRoles : null}
                // color="red"
                style={{
                  chips: {
                    background: 'blue',
                  },
                  searchBox: {
                    background: 'white',
                  },
                }}
                showCheckbox="true"
                onSelect={(e, info) => handleSelect(info, 'add', selectedRoles, setSelectedRoles)}
                onRemove={(e, info) =>
                  handleSelect(info, 'remove', selectedRoles, setSelectedRoles)
                }
                displayValue="name"
              />
              <div className="message-text error-message">
                <p>{errorData.selectedRoles}</p>
              </div>
            </CCol>
          </CRow>

          <CRow className="mt-3">
            <CCol lg="12">
              <CFormLabel>Select Users</CFormLabel>
              <Multiselect
                options={userData} // Options to display in the dropdown
                selectedValues={!isEmpty(groupData) ? selectedEditUsers : null}
                // color="red"
                style={{
                  chips: {
                    background: 'blue',
                  },
                  searchBox: {
                    background: 'white',
                  },
                }}
                showCheckbox="true"
                onSelect={(e, info) => handleSelect(info, 'add', selectedUsers, setSelectedUsers)}
                onRemove={(e, info) =>
                  handleSelect(info, 'remove', selectedUsers, setSelectedUsers)
                }
                displayValue="name"
              />
              <div className="message-text error-message">
                <p>{errorData.selectedUsers}</p>
              </div>
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleCreate}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default UserGroupModal
